// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"200":"8079598d","277":"da93fe36"}[chunkId] + ".chunk.css";
};